// extracted by mini-css-extract-plugin
export default {"Pagination":"pagination-container_Pagination__nR3Q8","PaginationResults":"pagination-container_PaginationResults__CNGLg"};